export default __webpack_public_path__ + "static/media/POPPINS-SEMIBOLD (1).e67a02ce.TTF";